import { OpsCashPictureStrip } from "./OpsCashPictureStrip";
import { OpsSalesAggregationStrip } from "./OpsSalesAggregationStrip";

export function OpsFinancialsFold(props: { enabled: boolean }) {
  if (!props.enabled) return null;
  return (
    <details className="rounded-xl border border-gray-200 bg-white dark:border-zinc-700 dark:bg-zinc-900">
      <summary className="cursor-pointer px-3 py-2 text-sm font-semibold text-gray-900 dark:text-zinc-100">
        Financials
      </summary>
      <div className="space-y-3 px-3 pb-3">
        <OpsSalesAggregationStrip enabled />
        <OpsCashPictureStrip enabled />
      </div>
    </details>
  );
}
